import moment from 'moment'


const getYMD = (date, format = 'DDMMYYYY') => ({
  y: moment(date, format).format('YYYY'),
  m: moment(date, format).format('MM'),
  d: moment(date, format).format('DD'),
})


export default getYMD
